module.exports = {
  email: 'josh.yo.22@hotmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/joshwilger',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/joshwilger',
    },
    {
      name: 'YouTube',
      url: 'https://youtube.com/@Code.J',
    },
    {
      name: 'Itch',
      url: 'https://codej.itch.io/',
    },
    {
      name: 'Discord',
      url: 'https://discordapp.com/users/332548043540922370',
    },
  ],

  navLinks: [
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    aqua: '#00e3fc',
    purple: '#1b182e',
    darkPurple: '#12101f',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
